import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import { LocationContract  } from '@packages/contracts';
import type { LocationRegion } from '@packages/contracts';

import { PROVINCE_QUERY_KEY } from '../query-keys';

type ProvinceListRoute = typeof LocationContract['province']['list'];
type ProvinceListResponse = ClientInferResponseBody<ProvinceListRoute, 200>['result']['provinces'];

export type ProvinceListQueryOptions = UseQueryOptions<
	ProvinceListRoute,
	ClientArgs,
	ProvinceListResponse
>;

export const createProvinceListQueryOptions = (region?: LocationRegion): ProvinceListQueryOptions => ({
	queryData: { query: { region } },
	queryKey:  PROVINCE_QUERY_KEY.list(region ?? 'all'),

	retry: (failureCount, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: res => res.body.result.provinces,
});
